// Kurzerklärungen für die (i)-Hinweise in der App und die Links auf die
// Wissensartikel von toleranzrechnung.de. Alle Texte an einer Stelle, damit
// sie testbar bleiben und später übersetzt werden können. Herkunft nur per
// URL-Parameter (§ 25 TDDDG: nichts im Browser speichern).

export const WISSEN_BASIS = 'https://toleranzrechnung.de/wissen/';

export function wissenUrl(slug, { medium = 'menu', campaign = 'wissen' } = {}) {
  const pfad = slug ? `${WISSEN_BASIS}${slug}/` : WISSEN_BASIS;
  const q = new URLSearchParams({ utm_source: 'app', utm_medium: medium, utm_campaign: campaign });
  return `${pfad}?${q}`;
}

const A2 = { label: 'ISO-Passungen-Tabelle', slug: 'iso-passungen-tabelle' };
const A3 = { label: 'Toleranzen berechnen', slug: 'toleranzen-berechnen' };
const A4 = { label: 'Statistische Tolerierung', slug: 'statistische-tolerierung' };
const A5 = { label: 'ISO 2768 Allgemeintoleranzen', slug: 'iso-2768-allgemeintoleranzen' };
const A6 = { label: 'Maßkette und Schließmaß', slug: 'masskette-schliessmass' };
const A7 = { label: 'Wärmeausdehnung in der Maßkette', slug: 'waermeausdehnung-masskette' };
const A8 = { label: 'Welche Verteilung für welches Maß?', slug: 'verteilung-toleranzrechnung' };
const A9 = { label: 'Toleranzbeitrag', slug: 'toleranzbeitrag' };

export const WISSEN_HINWEISE = {
  richtung: {
    titel: 'Richtung (+/−)',
    text: 'Plus heißt: Das Maß vergrößert das Schließmaß. Minus heißt: Es verkleinert es. '
      + 'Denk das Schließmaß als Spalt, dann bedeutet ein positives Ergebnis Spiel und ein negatives Klemmung.',
    links: [A6],
  },
  norm: {
    titel: 'Norm',
    text: 'Eine Toleranzklasse wie H7 oder g6 setzt die Abmaße nach ISO 286, ISO 2768 die Allgemeintoleranz '
      + 'für Maße ohne eigene Angabe. Änderst du die Abmaße von Hand, markiert die App die Zeile.',
    links: [A2, A5],
  },
  material: {
    titel: 'Material und Temperatur',
    text: 'Zeichnungsmaße gelten bei 20 °C. Jeder Werkstoff dehnt sich mit seinem eigenen '
      + 'Ausdehnungskoeffizienten aus. Sind die Teile aus verschiedenen Werkstoffen, verschiebt sich '
      + 'das Schließmaß mit der Temperatur.',
    links: [A7],
  },
  sollGrenzen: {
    titel: 'Soll-Grenzen',
    text: 'Hier trägst du ein, welchen Bereich das Schließmaß einhalten muss, etwa das kleinste zulässige Spiel. '
      + 'Ein leeres Feld heißt: keine Grenze auf dieser Seite. Die Bewertung vergleicht das Ergebnis der '
      + 'gewählten Methode mit diesen Grenzen.',
    links: [A6],
  },
  methoden: {
    titel: 'Berechnungsmethoden',
    text: 'Worst Case nimmt an, dass alle Maße gleichzeitig am ungünstigsten Rand liegen, und liefert '
      + 'garantierte Grenzen. RSS rechnet die erwartete Streuung einer Serie und geht davon aus, dass jedes '
      + 'Maß normalverteilt ist und alle unabhängig streuen; liegen Maße eher gleichmäßig im Feld, fällt RSS '
      + 'zu optimistisch aus. Monte Carlo simuliert viele Baugruppen mit der Verteilung, die du je Maß wählst.',
    links: [A3, A4, A8],
  },
  verteilung: {
    titel: 'Verteilung',
    text: 'Die Verteilung beschreibt, wie sich die Teile einer Serie im Toleranzfeld verteilen. '
      + 'Normal passt zu stabilen Serienprozessen (mit Fähigkeitsnachweis trägst du dort den Cpk ein), '
      + 'Gleich zu Maßen, die durchs Feld wandern, etwa durch Werkzeugverschleiß mit Nachstellen, '
      + 'oder zu Zukaufteilen ohne Nachweis. '
      + 'Sie wirkt nur in Monte Carlo, RSS rechnet jedes Maß als normalverteilt.',
    links: [A8],
  },
  beitrag: {
    titel: 'Beitragsleister',
    text: 'Die Leiste zeigt, wie viel jedes Maß zur Streuung des Schließmaßes beiträgt. '
      + 'Worst Case teilt linear nach Toleranzbreite, RSS und Monte Carlo nach Varianz, dort zählt eine '
      + 'doppelte Toleranz vierfach. Willst du das Schließmaß verbessern, setz beim größten Balken an.',
    links: [A9, A8],
  },
  rss: { links: [A4] },
};
